module.exports = __webpack_public_path__ + "static/media/cutscene-0.00bf7843.mp4";